/* Zeel launch design */
(function () {
  'use strict';
  /* home page: pick a goal, see its product */
  var bar = document.querySelector('[data-zn-goals]');
  if (bar) {
    var btns = [].slice.call(bar.querySelectorAll('[data-zn-goal]'));
    var panels = [].slice.call(document.querySelectorAll('[data-zn-panel]'));
    var wrap = panels[0] && panels[0].parentNode;
    var show = function (k, scroll) {
      var hit = false;
      panels.forEach(function (p) { var on = p.id === 'c-' + k; p.classList.toggle('on', on); if (on) hit = true; });
      if (!hit) return false;
      btns.forEach(function (b) {
        var on = b.getAttribute('data-zn-goal') === k;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: b.offsetLeft - 22, behavior: 'smooth' });
      });
      if (scroll) {
        var y = bar.getBoundingClientRect().top + window.pageYOffset - 150;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
      return true;
    };
    if (wrap) wrap.classList.add('zn-tabs');
    var first = (location.hash.match(/^#c-(\w+)$/) || [])[1];
    if (first && show(first, false)) setTimeout(function () { show(first, true); }, 250);
    else show(btns[0].getAttribute('data-zn-goal'), false);
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zn-goal]');
      if (b) show(b.getAttribute('data-zn-goal'), false);
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#c-"]');
      if (!a) return;
      if (show(a.getAttribute('href').slice(3), true)) e.preventDefault();
    });
  }
  /* product page: phone "Add to cart" bar, kept in step with the main control */
  var pb = document.querySelector('[data-zp-bar]');
  var form = document.getElementById('zp-form');
  var btn = form && form.querySelector('button[type=submit]');
  if (pb && btn) {
    var add = pb.querySelector('[data-zp-bar-add]');
    var sub = pb.querySelector('span');
    var price = sub ? sub.textContent : '';
    var check = function () { pb.classList.toggle('on', form.getBoundingClientRect().bottom < 0); };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
    add.addEventListener('click', function () {
      var plus = form.querySelector('.zqstep:not([hidden]) [data-d="1"]');
      if (plus) plus.click();
      else if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
    });
    var sync = function () {
      var st = form.querySelector('.zqstep');
      var n = st && !st.hidden ? parseInt(st.querySelector('b').textContent, 10) || 0 : 0;
      add.textContent = n > 0 ? 'Add one more' : 'Add to cart';
      if (sub) sub.textContent = n > 0 ? n + ' in cart' : price;
    };
    new MutationObserver(sync).observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
    sync();
  }
})();
